import React from 'react'
import styled from 'styled-components'
import { t } from '@/i18n'

interface ResourceLevelProps {
  level: 'ResourceLevelSenior' | 'ResourceLevelMiddle' | 'ResourceLevelJunior' | string
}

const ResourceLevel: React.FC<ResourceLevelProps> = ({ level }) => {
  const levelConfig = {
    ResourceLevelSenior: { label: t('高级'), color: '#fff', bg: '#F44F4F' },
    ResourceLevelMiddle: { label: t('中级'), color: '#fff', bg: '#FFA709' },
    ResourceLevelJunior: { label: t('初级'), color: '#fff', bg: '#6F9FFF' },
  }

  const config = levelConfig[level as keyof typeof levelConfig] || levelConfig.ResourceLevelJunior

  return (
    <StyledTag bgColor={config.bg} color={config.color}>
      {config.label}
    </StyledTag>
  )
}

const StyledTag = styled.span<{ bgColor: string; color: string }>`
  display: inline-block;
  height: 18px;
  padding: 0 4px;
  background: ${props => props.bgColor};
  border-radius: 4px;
  line-height: 18px;
  color: ${props => props.color};
  font-size: 12px;
  margin-right: 4px;
`

export default ResourceLevel
